import React, { useState, useContext } from 'react';
import classNames from 'classnames';
import ESIInclude from '@JohnLewisPartnership/jl-esi-components';
import { SecondaryButton } from 'jl-ui-kit/elements/button/Button';
// eslint-disable-next-line import/no-named-as-default
import NavigationItem from '../navigation-item/NavigationItem';
import Flyout from '../flyout/Flyout';
import notifyAnalytics from '../notify-analytics';
import FeedbackItem from '../feedback-item/FeedbackItem';
import MobileNavigationLinks from '../mobile-links/MobileLinks';
import EnvVarsFeaturesContext from '../../../scaffold/EnvVarsFeaturesContext';
import { isDesktop } from '../../../utils/device/identifyDevice';

import styles from '../navigation.scss';

function NavigationPane({
  authenticated,
  visible,
  backLabel,
  id,
  categoryLink,
  name = '',
  depth = 0,
  child = [],
  hierarchy = '',
  fetchAndStoreChildCategories,
  navigationV2Active,
  goBack,
  scrollToTop,
  isOverrideCategoryChild = false,
}) {
  const [opened, setOpened] = useState(false);
  const childHierarchy =
    depth > 0 ? `${hierarchy ? `${hierarchy}|` : ''}${name}` : '';

  const {
    categoryOverrides,
    categoryOverridesId: overrideTestName,
  } = useContext(EnvVarsFeaturesContext);

  const categoryOverrideId =
    id && categoryOverrides && categoryOverrides[id]
      ? categoryOverrides[id].id
      : '';

  const isOverrideCategory = overrideTestName && id === categoryOverrideId;

  const navigationItems =
    categoryOverrides && categoryOverrides[id]
      ? categoryOverrides[id].child
      : child;

  return (
    <div
      aria-hidden={depth > 0 && !visible}
      className={classNames(styles.navigationPane, {
        [styles.flyout]: depth === 1,
        [styles.cascaded]: opened,
      })}
    >
      {depth > 0 && (
        <button className={classNames(styles.back)} onClick={goBack}>
          <span className={styles.buttonLabel}>{backLabel || 'Back'}</span>
        </button>
      )}
      {name.length > 0 && (
        <h3 className={styles.paneTitle}>
          {categoryLink ? (
            <a
              href={categoryLink}
              alt={name}
              onClick={() => notifyAnalytics(childHierarchy)}
            >
              {name}
            </a>
          ) : (
            name
          )}
        </h3>
      )}
      {// eslint-disable-next-line no-constant-condition
      false ? (
        <Flyout
          visible={visible}
          name={name}
          child={navigationItems}
          fetchAndStoreChildCategories={fetchAndStoreChildCategories}
          navigationV2Active={navigationV2Active}
          scrollToTop={scrollToTop}
          childHierarchy={childHierarchy}
          setOpened={setOpened}
        />
      ) : (
        <ul
          className={classNames(styles.items, {
            [styles.navBar]: depth === 0,
          })}
        >
          {navigationItems.map(item =>
            depth === 3 && !isOverrideCategoryChild ? (
              <li className={styles.nestedItems}>
                <h4 className={styles.nestedTitle}>{item.name}</h4>
                <ul className={styles.items}>
                  {item.child &&
                    item.child.map(subitem => (
                      <NavigationItem
                        {...subitem}
                        key={subitem.id}
                        depth={depth}
                        id={subitem.id}
                        visible={visible}
                        hierarchy={`${childHierarchy}|${item.name}`}
                        scrollToTop={scrollToTop}
                      />
                    ))}
                </ul>
              </li>
            ) : (
              <NavigationItem
                {...item}
                key={item.id}
                depth={depth}
                id={item.id}
                hierarchy={childHierarchy}
                backLabel={name}
                toggleParentOpened={setOpened}
                fetchAndStoreChildCategories={fetchAndStoreChildCategories}
                parentOpen={visible}
                openClass={styles.opened}
                navigationV2Active={navigationV2Active}
                scrollToTop={scrollToTop}
                isOverrideCategoryChild={
                  isOverrideCategory || isOverrideCategoryChild
                }
              />
            )
          )}
          {depth === 0 && (
            <NavigationItem
              name="Inspiration"
              url="/content"
              className={styles.mobile}
              id="the-edit"
              depth={depth}
              parentOpen={visible}
              navigationV2Active={navigationV2Active}
              scrollToTop={scrollToTop}
              isOverrideCategory={isOverrideCategory}
            />
          )}
        </ul>
      )}
      {depth === 0 && (
        <>
          <MobileNavigationLinks authenticated={authenticated} />
          <FeedbackItem />
        </>
      )}
      {depth === 1 && !isOverrideCategory && (
        <div className={styles.banner} data-testid="navigation-content">
          <ESIInclude
            src={`/content-renderer/navigation/${id}?no-hydration=true&no-failure=true&includePolyfills=false&includeCoreJS=false`}
            id="navigation-content"
          />
        </div>
      )}
      {depth === 1 && isDesktop() && isOverrideCategory && (
        <SecondaryButton tag="a" href={categoryLink}>
          View all Home & Garden
        </SecondaryButton>
      )}
    </div>
  );
}

export default NavigationPane;
